<div class="flex-auto flex items-center justify-between container px-6">
  <div class="text-sm text-white/80">
    © {{ currentYear }} {{ env.academyFullName }}. Todos los derechos reservados.
  </div>
  <div class="text-sm text-white/60">
    Hecho por <a href="https://www.miclickderecho.com" target="_blank" rel="noopener" class="text-white hover:text-white/90 underline">MiClickDerecho</a>
  </div>
</div>
